export function EmptyChar() {
	return <>&nbsp;</>;
}
